/**
 * Einmal in main.tsx jeder App importieren:  import '@pilot-hub/ui/theme/init'
 * - lädt die selbst gehosteten Schriften (Inter + JetBrains Mono für wall, Manrope + Space Grotesk für glass)
 * - setzt data-ui am <html> (wall | glass) und hält es aktuell
 */
import '@fontsource-variable/inter'
import '@fontsource-variable/jetbrains-mono'
import '@fontsource-variable/manrope'
import '@fontsource-variable/space-grotesk'
import { initUiTheme } from './uiTheme'

initUiTheme()
